import React, { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Wine, Loader } from "lucide-react";

const S = {
  page:{minHeight:"100vh",background:"#F2F5EC",display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'Inter',sans-serif"},
  box:{background:"#EDF1E4",border:"1px solid #252525",borderRadius:14,padding:"36px 32px",width:"100%",maxWidth:380},
  label:{fontSize:10,fontWeight:600,color:"#7A8E68",textTransform:"uppercase",letterSpacing:"0.1em",display:"block",marginBottom:6},
  input:{width:"100%",background:"#E8EDE0",border:"1px solid #222",borderRadius:8,padding:"11px 14px",fontSize:13,color:"#2C3820",fontFamily:"'Inter',sans-serif",outline:"none",boxSizing:"border-box",marginBottom:12},
  btn:{width:"100%",padding:"12px",background:"#6B2737",border:"none",borderRadius:8,color:"#DCE4EC",fontSize:14,fontWeight:500,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:8},
};

export default function LoginPage() {
  const [email,setEmail]=useState("");
  const [password,setPassword]=useState("");
  const [loading,setLoading]=useState(false);
  const [error,setError]=useState("");
  const { login } = useAuth("winery_owner");
  const navigate = useNavigate();
  const location = useLocation();

  const submit = async e => {
    e.preventDefault(); setError(""); setLoading(true);
    try { await login(email, password); navigate(location.state?.from || "/manage"); }
    catch(err) { setError(err.message); }
    finally { setLoading(false); }
  };

  return (
    <div style={S.page}>
      <div style={S.box}>
        <div style={{textAlign:"center",marginBottom:28}}>
          <Wine size={28} color="#6B2737" style={{marginBottom:10}}/>
          <h1 style={{fontFamily:"'Playfair Display',serif",fontSize:22,color:"#1E2C14",margin:"0 0 4px"}}>Winery Manager</h1>
          <p style={{fontSize:12,color:"#6A7E58",margin:0}}>Sign in to manage your winery</p>
        </div>
        {error && <div style={{background:"rgba(107,39,55,0.1)",border:"1px solid rgba(107,39,55,0.2)",borderRadius:7,padding:"8px 12px",marginBottom:14,fontSize:12,color:"#886070"}}>{error}</div>}
        <form onSubmit={submit}>
          <label style={S.label}>Email</label>
          <input style={S.input} type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="you@winery.com" required/>
          <label style={S.label}>Password</label>
          <input style={S.input} type="password" value={password} onChange={e=>setPassword(e.target.value)} placeholder="••••••••" required/>
          <div style={{textAlign:"right",margin:"-4px 0 14px"}}>
            <Link to="/forgot-password" state={{email, role:"winery_owner"}} style={{fontSize:12,color:"#886070",textDecoration:"none"}}>Forgot password?</Link>
          </div>
          <button type="submit" style={S.btn} disabled={loading}>
            {loading ? <Loader size={14}/> : null} Sign in
          </button>
        </form>
        <p style={{textAlign:"center",fontSize:12,color:"#6A7E58",marginTop:20}}>
          No account? <Link to="/manage/signup" style={{color:"#886070",textDecoration:"none"}}>Register your winery</Link>
        </p>
      </div>
    </div>
  );
}
